var $ = require('jquery'),
    jQueryBridget = require('jquery-bridget'),
    isotope = require('isotope-layout'),
    imagesLoaded = require('imagesloaded');

import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/optimumx/ls.optimumx';

'use strict';

window.theme = window.theme || {};

theme.Isotope = function() {

    function Isotope() {
        this.load();
    };

    Isotope.prototype = $.extend({}, Isotope.prototype, {
        load: function() {
            jQueryBridget('isotope', isotope, $);

            this.init();
        },
        init: function() {
            var $demos_list = $('.js-demos-list'),
                $isotope = $demos_list.isotope({
                    itemSelector: '[data-js-demos-item]',
                    filter: '.filter-home'
                });

            $(document).on('lazyloaded', function () {
                $demos_list.isotope('layout');
            });

            $(function () {
                $demos_list.isotope('layout');

                setTimeout(function() {
                    $demos_list.isotope('layout');
                }, 3000);
            });

            /*$isotope.imagesLoaded().progress( function() {
                $demos_list.isotope('layout');
            });*/

            $('.js-demos-menu').on('click', '[data-filter]', function(e) {
                var $this = $(this),
                    value = $this.attr('data-filter');

                $this.parents('.js-demos-menu').find('[data-filter]').removeClass('active');
                $this.addClass('active');
                
                $demos_list.isotope({ filter: value });

                e.preventDefault();
                return false;
            });
        }
    });

    theme.Isotope = new Isotope;
};

theme.Lazyload = function() {

    function Lazyload() {
        this.load();
    };

    Lazyload.prototype = $.extend({}, Lazyload.prototype, {
        load: function() {
            imagesLoaded.makeJQueryPlugin($);
            lazySizes.init();
        }
    });

    theme.Lazyload = new Lazyload;
};

theme.Global = function() {

    function Global() {
        this.settings = {
            set_offset_with_fixed_body: [
                '.header__content--sticky'
            ]
        };

        this.load();
    };

    Global.prototype = $.extend({}, Global.prototype, {
        load: function() {
            var current_bp,
                $scroll_example = $('.scroll-offset-example');

            window.$window = $(window);
            window.$html = $('html');
            window.$body = $html.find('body');

            theme.rtl = $body.attr('dir') === 'rtl' ? true : false;

            theme.breakpoints = {
                values: {
                    xs: 0,
                    sm: 556,
                    md: 768,
                    lg: 992,
                    xl: 1260
                }
            };
            theme.breakpoints.main = theme.breakpoints.values.lg;
            theme.current = {};

            function checkWindow() {
                theme.current.width = window.innerWidth;
                theme.current.height = window.innerHeight;
            };

            function checkBreakpoint() {
                theme.current.is_mobile = theme.current.width < theme.breakpoints.main;
                theme.current.is_desktop = !theme.current.is_mobile;

                $.each(theme.breakpoints.values, function(k, v) {
                    if(v > theme.current.width) {
                        return false;
                    }

                    theme.current.bp = k;
                });

                if(current_bp && current_bp != theme.current.bp) {
                    $(window).trigger('theme.changed.breakpoint');
                }

                current_bp = theme.current.bp;
            };

            function scrollPaddingStyle() {
                var $style = $('style.scroll-offset-style');

                theme.current.scroll_w = $scroll_example[0].offsetWidth - $scroll_example[0].clientWidth;

                if(theme.current.scroll_w > 0) {
                    if(!$style.length) {
                        var offset_scroll_style_html = 'body.offset-scroll-styles{padding-right:' + theme.current.scroll_w + 'px;}.fixed-elem.offset-scroll{padding-right:' + theme.current.scroll_w + 'px;}';

                        $('head').append($('<style>').addClass('scroll-offset-style').html(offset_scroll_style_html));
                    }
                } else {
                    $style.remove();
                }
            };

            $(window).on('resize', function() {
                checkWindow();
                checkBreakpoint();

                $(window).trigger('theme.resize');
            });

            $(window).on('theme.changed.breakpoint', function() {
                scrollPaddingStyle();
            });

            checkWindow();
            checkBreakpoint();
            scrollPaddingStyle();

            $(window).on('load', function () {
                theme.is_loaded = true;
            });
        },
        bodyHasScroll: function(prop) {
            var d = document,
                e = d.documentElement,
                b = d.body,
                client = "client" + prop,
                scroll = "scroll" + prop;

            return /CSS/.test(d.compatMode) ? (e[client] < e[scroll]) : (b[client] < b[scroll]);
        },
        fixBody: function() {
            if (this.bodyHasScroll('Height')) {
                $body.addClass('offset-scroll');
                $.each(this.settings.set_offset_with_fixed_body, function(i, k) {
                    $(k).addClass('offset-scroll fixed-elem');
                });
            }

            this._fixed_scroll_top = pageYOffset;

            $body.css({ top: pageYOffset * -1 });
            $body.addClass('offset-scroll-styles');
        },
        unfixBody: function() {
            $body.removeClass('offset-scroll offset-scroll-styles');

            $body.add($html).scrollTop(this._fixed_scroll_top);
            this._fixed_scroll_top = null;

            $body.css({ top: '' });

            $.each(this.settings.set_offset_with_fixed_body, function(i, k) {
                $(k).removeClass('fixed-elem offset-scroll');
            });
        },
        responsiveHandler: function(obj) {
            var namespace = obj.namespace ? obj.namespace : '.widthHandler',
                current_bp;

            function bind() {
                $.each(obj.events, function(event, func) {
                    if(obj.delegate) {
                        $(obj.element).on(event + namespace, obj.delegate, func);
                    } else {
                        $(obj.element).on(event + namespace, func);
                    }
                });
            };

            function unbind() {
                $.each(obj.events, function(event) {
                    $(obj.element).unbind(event + namespace);
                });
            };

            function on_resize() {
                if(theme.current.is_mobile !== current_bp) {
                    current_bp = theme.current.is_mobile;

                    if((obj.on_desktop && theme.current.is_desktop) || (obj.on_mobile && theme.current.is_mobile)) {
                        bind();
                    } else {
                        unbind();
                    }
                }
            };

            $(window).on('theme.resize' + namespace, function() {
                on_resize();
            });

            on_resize();

            return {
                unbind: function() {
                    $(window).unbind('theme.resize' + namespace);
                    unbind();
                }
            }
        },
    });

    theme.Global = new Global;
};

theme.StickyHeader = function() {

    function StickyHeader() {
        this.load();
    };

    StickyHeader.prototype = $.extend({}, StickyHeader.prototype, {
        load: function() {
            var $sticky = $('.js-header-sticky');

            this._create($sticky, {
                bp: 992,
                desktop: {
                    sticky: '[data-js-desktop-sticky]',
                    limit: 400,
                    fade: true,
                    duration: 300
                },
                mobile: {
                    sticky: '[data-js-mobile-sticky]',
                    limit: 'bottom',
                    fade: true,
                    duration: 300
                }
            });
        },
        _create: function($elem, params) {
            this.options = params;
            this.bindings = $elem;

            var _ = this,
                $elem = this.bindings,
                $sticky_m = $elem.find(this.options.mobile && this.options.mobile.sticky ? this.options.mobile.sticky : ''),
                $sticky_d = $elem.find(this.options.desktop && this.options.desktop.sticky ? this.options.desktop.sticky : ''),
                $spacer_m = $('<div>').addClass('header__spacer header__spacer--m').insertBefore($sticky_m),
                $spacer_d = $('<div>').addClass('header__spacer header__spacer--d').insertBefore($sticky_d);

            this.sticky_class = 'header__content--sticky';

            function fix() {
                _._fix(_.$sticky, _.$spacer);
                _._move(_.options[_.bp]);
            };

            function unfix() {
                _._unfix(_.$sticky, _.$spacer);
                _._return(_.options[_.bp]);
            };

            function on_resize() {
                var is_desktop = theme.current.is_desktop;

                _.bp = is_desktop ? 'desktop' : 'mobile';
                _.$sticky = is_desktop ? $sticky_d : $sticky_m;
                _.$spacer = is_desktop ? $spacer_d : $spacer_m;

                if(!_.$sticky.length) {
                    return;
                }

                if (is_desktop) {
                    $spacer_m.removeClass('header__spacer--visible');
                    $spacer_d.addClass('header__spacer--visible');

                    if ($sticky_m.hasClass(_.sticky_class)) {
                        _._unfix($sticky_m, $spacer_m);
                        _._return(_.options.mobile);
                    }
                } else {
                    $spacer_d.removeClass('header__spacer--visible');
                    $spacer_m.addClass('header__spacer--visible');

                    if ($sticky_d.hasClass(_.sticky_class)) {
                        _._unfix($sticky_d, $spacer_d);
                        _._return(_.options.desktop);
                    }
                }
            };

            function on_scroll() {
                if(!_.$sticky.length) return;

                var limit = _.options[_.bp].limit ? _.options[_.bp].limit : 0,
                    spacer_pos = _.$spacer[0].getBoundingClientRect();

                if (limit === 'bottom') {
                    limit = _.$sticky.hasClass(_.sticky_class) ? _.$spacer.innerHeight() : _.$sticky.innerHeight();
                }

                limit *= -1;

                if (spacer_pos.top < limit) {
                    if (!_.$sticky.hasClass(_.sticky_class)) {
                        fix();
                    }
                } else {
                    if (_.$sticky.hasClass(_.sticky_class)) {
                        unfix();
                    }
                }
            };

            on_resize();
            on_scroll();

            $window.on({
                'theme.resize.stickyHeader': function() {
                    on_resize();
                    on_scroll();
                },
                'scroll.stickyHeader': on_scroll
            });
        },
        _fix: function($sticky, $spacer) {
            var height = $sticky.innerHeight();

            $spacer.height(height);

            if(this.options[this.bp].fade) {
                $sticky.css({ 'opacity': 0 }).animate({ 'opacity': 1 }, this.options[this.bp].duration);
            }

            $sticky.addClass(this.sticky_class);
        },
        _unfix: function($sticky, $spacer) {
            $spacer.removeAttr('style');

            if(this.options[this.bp].fade) {
                $sticky.stop(true);
            }

            $sticky.removeAttr('style').removeClass(this.sticky_class);
        },
        _move: function(obj) {
            if (!obj.move) return;

            $.each(obj.move, function() {
                var $elem = $(this.elem),
                    $to = $(this.to),
                    method = this.method || 'append';

                this.$elem = $elem;
                this.$parent = $elem.parent();

                $to[method]($elem);
            });
        },
        _return: function(obj) {
            if (!obj.move) return;

            $.each(obj.move, function() {
                var method = this.method || 'append';

                this.$parent[method](this.$elem);
                this.$elem = null;
                this.$parent = null;
            });
        },
        _check_height: function($sticky, obj) {
            if(!obj.height) return;

            var spacer_pos = this.$spacer[0].getBoundingClientRect(),
                height = spacer_pos.bottom <= obj.height ? obj.height : spacer_pos.bottom;

            $sticky.css({ 'min-height': height });
        },
        getStickyHeight: function() {
            return this.options[this.bp] ? (this.options[this.bp].height || $(this.options[this.bp].sticky).innerHeight()) : 0;
        },
        destroy: function() {
            $(window).unbind('resize.stickyHeader scroll.stickyHeader');

            $.Widget.prototype.destroy.call(this);
        }
    });

    theme.StickyHeader = new StickyHeader;
};

theme.Video = function() {

    function Video() {
        this.load();
    };

    Video.prototype = $.extend({}, Video.prototype, {
        load: function() {
            var $video = $('.js-video');

            function setHeight() {
                if(theme.current.is_desktop) {
                    $video.height(theme.current.height);
                } else {
                    $video.removeAttr('style');
                }
            };

            setHeight();
            $window.on('theme.resize', setHeight);

            if($video.length) {
                function lazyvideo() {
                    $('.lazyvideo').each(function () {
                        var $this = $(this),
                            $parent = $this.parent(),
                            parent_w = $parent.innerWidth(),
                            data_src = $this.attr('data-src'),
                            data_sizes = $this.attr('data-sizes'),
                            i = 0,
                            size,
                            src;

                        data_sizes = data_sizes.replace(new RegExp(' ', 'g'), '').split(',');

                        for(; i < data_sizes.length; i++) {
                            if(i === data_sizes.length - 1 && parent_w >= +data_sizes[i]) {
                                size = +data_sizes[i];
                            } else if(i === 0 && parent_w <= +data_sizes[i]) {
                                size = +data_sizes[i];
                            } else if(parent_w > +data_sizes[i] && parent_w <= +data_sizes[i + 1]) {
                                size = +data_sizes[i + 1];
                            }

                            if(size && size !== +$this.attr('data-current-size')) {
                                $this.unbind('loadeddata').one('loadeddata', function () {
                                    setTimeout(function () {
                                        $this.addClass('loaded');
                                    }, 100);
                                });

                                $this.attr('src', data_src.replace('{size}', size)).attr('data-current-size', size);

                                break;
                            }
                        }
                    });
                };

                $window.on('theme.resize', function() {
                    lazyvideo();
                });

                lazyvideo();
            }
        }
    });

    theme.Video = new Video;
};

theme.FixedFooter = function() {

    function FixedFooter() {
        this.load();
    };

    FixedFooter.prototype = $.extend({}, FixedFooter.prototype, {
        load: function() {
            var $footer = $('.js-footer');

            if($footer.length && $footer[0].hasAttribute('data-js-footer-fixed')) {
                var $parent = $footer.parent(),
                    $main = $('#main');

                function calculate() {
                    var footer_height = $footer.innerHeight(),
                        can_fix = $main.innerHeight() > footer_height + window.innerHeight;

                    $footer[can_fix && theme.current.is_desktop ? 'addClass' : 'removeClass']('footer--fixed');

                    $footer.css({
                        width: theme.current.is_desktop && $parent.hasClass('container') ? $parent.width() + 'px' : ''
                    });

                    $main.css({
                        marginBottom: can_fix && theme.current.is_desktop ? footer_height + parseInt($footer.css('margin-top')) : ''
                    });
                };

                $window.on('theme.resize.fixedfooter', calculate);

                calculate();
            }
        }
    });

    theme.FixedFooter = new FixedFooter;
};

theme.Menu = function() {

    function Menu() {
        this.load();
    };

    Menu.prototype = $.extend({}, Menu.prototype, {
        load: function() {
            $body.on('click', 'a[href^="#"]', function (e) {
                var $this = $(this);

                theme.Popups.closeByName('menu', null, function() {
                    $html.add($body).animate({
                        scrollTop: $($this.attr('href')).offset().top - theme.StickyHeader.getStickyHeight()
                    });
                });

                e.preventDefault();
                return false;
            });
        }
    });

    theme.Menu = new Menu;
};

theme.Popups = function() {

    function Popups() {
        this.selectors = {
            popup: '.js-popup',
            button: '.js-popup-button',
            button_close: '[data-js-popup-close]',
            bg: '[data-js-popup-bg]'
        };

        this.load();
    };

    Popups.prototype = $.extend({}, Popups.prototype, {
        load: function() {
            if($(this.selectors.popup).length) {
                var _ = this;

                $body.on('click', this.selectors.button, function(e) {
                    var $this = $(this),
                        name = $this.attr('data-js-popup-button');

                    if(_.callByName(name, $this)) {
                        e.preventDefault();
                        return false;
                    }
                });

                $body.on('click', this.selectors.button_close, function(e) {
                    var $this = $(this),
                        name = $this.parents('[data-js-popup-name]').attr('data-js-popup-name');

                    _.closeByName(name, $this);

                    e.preventDefault();
                    return false;
                });

                $body.on('click', this.selectors.popup + ' [data-js-popup-name]', function(e) {
                    var $t = $(e.target);

                    if($t[0].hasAttribute('data-js-popup-name')) {
                        var name = $t.attr('data-js-popup-name');

                        _.closeByName(name, $t);
                    }
                });

                setTimeout(function() {
                    $body.find(_.selectors.popup + ' [data-js-auto-call="true"]').each(function() {
                        _.callByName($(this).attr('data-js-popup-name'));
                    });
                }, 0);
            }
        },
        callByName: function(name, $target, callback) {
            var _ = this,
                $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                is_ajax = $content.attr('data-js-popup-ajax') !== undefined ? true : false;

            if($content.length) {
                if(theme.current.is_desktop && $content[0].hasAttribute('data-js-popup-mobile-only')) {
                    return false;
                }

                function onCall() {
                    $popup.scrollTop(0);

                    $bg.one('transitionend', function () {
                        $content.add($bg).removeClass('animate');

                        $content.trigger('call.after', [$content, $target ? $target : null]);

                        if(callback) {
                            callback(true);
                        }
                    });

                    $content.add($bg).addClass('animate');

                    setTimeout(function () {
                        $content.add($bg).addClass('visible');

                        if($bg.css('transition-duration') === '0s') {
                            $bg.trigger('transitionend');
                        }
                    }, 0);

                    if($content[0].hasAttribute('data-js-popup-mobile-only')) {
                        $window.on('theme.changed.breakpoint.popups', function() {
                            if(!theme.current.is_mobile) {
                                _.closeByName(name);
                            }
                        });
                    }
                };

                $bg.unbind('transitionend');

                $content.trigger('call.before', [$content, $target ? $target : null]);

                $popup.addClass('active');

                $popup.find('[data-js-popup-name]').removeClass('show visible');
                $popup.add($content).addClass('show');

                theme.Global.fixBody();

                if(is_ajax) {
                    $content.addClass('is-process-loading');

                    $content.on('contentloaded', function () {
                        $content.removeClass('is-process-loading');

                        onCall();
                    });
                } else {
                    onCall();
                }

                $body.on('keyup.popups', function(e) {
                    if(e.keyCode === 27) {
                        _.closeAll();
                    }
                });

                $content.trigger('call.visible', [$content, $target ? $target : null]);

                return true;
            } else {
                if(callback) {
                    callback(false);
                }

                return false;
            }
        },
        closeByName: function(name, $target, callback) {
            var $popup = $(this.selectors.popup),
                $bg = $(this.selectors.bg),
                $content = $popup.find('[data-js-popup-name="' + name + '"]'),
                duration = $bg.css('transition-duration');

            if($content.length && $content.hasClass('show')) {
                $content.unbind('contentloaded').removeClass('is-process-loading');
                $bg.unbind('transitionend');
                $body.unbind('keyup.popups');
                $window.unbind('theme.changed.breakpoint.popups');

                $content.trigger('close.before', [$content, $target ? $target : null]);

                $bg.one('transitionend', function () {
                    $popup.add($content).removeClass('show');
                    $content.add($bg).removeClass('animate');

                    theme.Global.unfixBody();

                    $popup.removeClass('active');

                    $content.trigger('close.after', [$content, $target ? $target : null]);

                    if(callback) {
                        callback(true);
                    }
                });

                $content.add($bg).addClass('animate');

                if(!$bg.hasClass('visible') || $bg.css('transition-duration') === '0s') {
                    $bg.trigger('transitionend');
                }

                $content.add($bg).removeClass('visible');

                return true;
            } else {
                if(callback) {
                    callback(false);
                }

                return false;
            }
        },
        closeAll: function() {
            var _ = this,
                $popup = $(this.selectors.popup + '.active'),
                $content = $popup.find('[data-js-popup-name]').filter('.show, .is-process-loading');

            if($content.length) {
                $content.each(function () {
                    _.closeByName($content.attr('data-js-popup-name'));
                });

                return true;
            } else {
                return false;
            }
        }
    });

    theme.Popups = new Popups;
};

theme.Previews = function() {

    function Previews() {
        this.settings = {
            duration_const: 2000,
            height_const: 500,
            easing: 'linear'
        };

        this.load();
    };

    Previews.prototype = $.extend({}, Previews.prototype, {
        load: function() {
            var _ = this;

            $body.on('mouseenter touchstart loadpreview', '.js-preview:not(.is-preview):not(.on-process)', function() {
                var $this = $(this),
                    $img = $this.find('img'),
                    $new_img = $('<img>').addClass('rimage__img lazyautosizes lazyloaded'),
                    srcset = $img.attr('srcset').replace(new RegExp('img/', 'g'), 'img/full_previews/');

                $this.addClass('on-process');

                $new_img.one('load', function() {
                    $img.replaceWith($new_img);

                    $img.off().remove();

                    $this.addClass('is-preview');

                    if($this.hasClass('hovered')) {
                        $this.trigger('scrolldown');
                    }

                    $this.removeClass('on-process');
                });

                $new_img.attr('sizes', Math.ceil($this.width()) + 'px').attr('srcset', srcset).attr('data-srcset', srcset);
            });

            $body.on('mouseenter mouseleave touchstart touchend scrolldown scrollup', '.js-preview.is-preview', function(e) {
                var $this = $(this),
                    $img = $this.find('img'),
                    dir = (e.type === 'mouseenter' || e.type === 'touchstart' || e.type === 'scrolldown') ? 'down' : 'up';

                $img.stop();

                var scroll_current = parseInt($img.css('top'), 10) * -1,
                    scroll_segment = $img.height() - $this.innerHeight();

                if(dir === 'down' && scroll_segment > 0) {
                    $img.animate({
                        top: scroll_segment * -1
                    }, {
                        duration: (scroll_segment - scroll_current) / _.settings.height_const * _.settings.duration_const,
                        easing: _.settings.easing
                    });
                } else if(scroll_current !== 0) {
                    $img.animate({
                        top: 0
                    }, {
                        duration: scroll_current / _.settings.height_const * _.settings.duration_const,
                        easing: _.settings.easing,
                        complete: function() {
                            $img.removeAttr('style');
                        }
                    });
                }

                $this[(e.type === 'mouseenter' || e.type === 'touchstart') ? 'addClass' : 'removeClass']('hovered');
            });

            $body.on('touchend', function() {
                $('.js-preview.is-preview').trigger('scrollup');
            });

            $body.on('lazyloaded', '.js-preview:not(.is-preview):not(.on-process)', function () {
                $(this).trigger('loadpreview');
            });
        }
    });

    theme.Previews = new Previews;
};

$(function() {
    theme.Isotope();
    theme.Lazyload();
    theme.Global();
    theme.StickyHeader();
    theme.Video();
    theme.FixedFooter();
    theme.Menu();
    theme.Popups();
    theme.Previews();
});